












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsArticle extends Vue {
  @Prop({ type: String, default: '' })
  name: string;

  @Prop({ type: String, default: '' })
  article: string;

  @Prop({ type: String, default: '' })
  infoText: string;

  @Prop({ type: Boolean, default: false })
  smallHeader: boolean;

  get isInfoText(): boolean {
    const { infoText } = this;
    return infoText && infoText.length;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/article/Articlehtml.vue